import script from "./SaldoBancoFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./SaldoBancoFormView.vue?vue&type=script&setup=true&lang=js"

import "./SaldoBancoFormView.vue?vue&type=style&index=0&id=634af0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634af0f6"]])

export default __exports__